module.exports = __webpack_public_path__ + "e8af9710c50254add7567c62b69acf69.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/raquel-velez.jpg
 ** module id = 425
 ** module chunks = 0
 **/